<template>
  <div class="d-flex justify-space-between align-center mb-3">
    <div class="d-flex" style="width: 50%;">
      <div class="type-wrapper mr-2" v-if="isInputTypeShown">
        <v-autocomplete
          label="Kiểu nhập"
          v-model="type"
          hide-details
          outlined
          dense
          :items="[
            { value: 'fixed', title: 'VND' },
            { value: 'percentage', title: '%' }
          ]"
          item-value="value"
          item-text="title"
        />
      </div>
      <div class="input-wrapper" :class="{ 'input-wrapper--with-type': isInputTypeShown }">
        <v-text-field
          :placeholder="priceValuePlaceholder"
          :label="priceValuePlaceholder"
          :value="price"
          @input="val => handlePrice(val, 'price_0')"
          outlined
          dense
          hide-details
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    labelTitle: String
  },
  data() {
    return {
      price: '0',
      type: 'fixed'
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    ...mapGetters({
      periods: 'tuitionFeePeriod/periods'
    }),
    priceValuePlaceholder() {
      if (this.router === 'normal') {
        if (!this.isSubFee) return 'Mức đóng (VNĐ)'
        return 'Mức truy thu (VNĐ)'
      }
      if (this.isSubFee) return 'Mức hoàn trả'
      return 'Mức giảm trừ'
    },
    isInputTypeShown() {
      return this.router === 'priority'
    }
  },
  methods: {
    handlePrice(value) {
      if (value) {
        let number = value.split(/\s*,\s*/).join('')
        this.price = (+number).toLocaleString('en-US')
      }
    }
  },
  watch: {
    price() {
      this.$emit('onPriceChange', this.price)
    },
    type() {
      this.$emit('onTypeChange', this.type)
    }
  }
}
</script>
<style lang="scss" scoped>
.input-wrapper {
  width: 100%;
}
.input-wrapper--with-type {
  width: 60%;
}
.type-wrapper {
  width: 40%;
}
</style>
